import { Badge, Box, HStack, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiSend } from "react-icons/fi";
import { PublicationDto } from "../../../autogen/bff-api";
import { useDisplayDate } from "../../../common/formatting/useDisplayDate";
import { SectionCard } from "../../sourcing-events/portal/view-single/SectionCard";

export const PublicationsSection = ({ publications }: { publications: PublicationDto[] }) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();

  if (publications.length === 0) return null;

  return (
    <SectionCard icon={FiSend} title={t("Publications")} count={publications.length}>
      <Stack spacing="2">
        {publications.map((p) => {
          const isChangeNotice = p.noticeVersion !== "01";
          return (
            <HStack
              key={p.id}
              borderWidth="1px"
              borderColor="smBorder"
              rounded="md"
              px="4"
              py="3"
              justify="space-between"
              spacing="3"
            >
              <Box minW="0">
                <Text color="smText" fontSize="sm" fontWeight="medium">
                  {t(p.channel)} · {isChangeNotice ? t("Change notice") : t(p.eFormType)}
                </Text>
                <Text color="smMuted" fontSize="xs">
                  {p.publishedAt ? displayDate(p.publishedAt) : t("Not published")}
                  {p.externalId ? ` · ${p.externalId}` : ""}
                  {` · ${t("Version")} ${p.noticeVersion}`}
                </Text>
              </Box>
              <Badge colorScheme={isChangeNotice ? "purple" : "gray"} textTransform="none">
                {t(p.status)}
              </Badge>
            </HStack>
          );
        })}
      </Stack>
    </SectionCard>
  );
};
